import type { SvgProps } from 'react-native-svg/lib/typescript/elements/Svg';

// Todo: maybe getting rid of this as prop passed to a component would be better. See GeoAreaSubscription. The Parent should take care of the labels, colors and callbacks
export const EditMode = {
  EDIT: 'edit',
  CREATE: 'create',
  REGISTRATION: 'registration',
  REQUIRED_ACTION: 'required_action',
  READ_ONLY: 'read_only'
} as const;

export type EditMode = (typeof EditMode)[keyof typeof EditMode];

export type SVGComponent = {
  // Todo: check if still needed after react update
  // Currently we get an error because of (props: P): ReactNode | Promise<ReactNode>;
  (props: SvgProps): React.ReactNode;
};

export type FlattenKeys<T, P extends string = ''> = T extends object
  ? { [K in keyof T & string]: FlattenKeys<T[K], `${P}${K}.`> }[keyof T &
      string]
  : P extends `${infer R}.`
    ? R
    : never;
